/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TableColumnConfig,
  TableColumnConfig$inboundSchema,
  TableColumnConfig$Outbound,
  TableColumnConfig$outboundSchema,
} from "./tablecolumnconfig.js";
import {
  TableRowConfig,
  TableRowConfig$inboundSchema,
  TableRowConfig$Outbound,
  TableRowConfig$outboundSchema,
} from "./tablerowconfig.js";
import {
  TableSortingState,
  TableSortingState$inboundSchema,
  TableSortingState$Outbound,
  TableSortingState$outboundSchema,
} from "./tablesortingstate.js";

/**
 * Specifies the configuration of the Table Visualization in Equipment Browser
 */
export type TableConfig = {
  /**
   * The columns of the table.
   */
  columns: Array<TableColumnConfig>;
  /**
   * The id of the table
   */
  id: string;
  /**
   * The rows of the table.
   */
  rows: Array<TableRowConfig>;
  /**
   * Sort state for a table. Mirrors tanstack's config..
   */
  sortingState?: TableSortingState | undefined;
  /**
   * The title of the table
   */
  title?: string | undefined;
};

/** @internal */
export const TableConfig$inboundSchema: z.ZodType<
  TableConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  columns: z.array(TableColumnConfig$inboundSchema),
  id: types.string(),
  rows: z.array(TableRowConfig$inboundSchema),
  sorting_state: types.optional(TableSortingState$inboundSchema),
  title: types.optional(types.string()),
}).transform((v) => {
  return remap$(v, {
    "sorting_state": "sortingState",
  });
});
/** @internal */
export type TableConfig$Outbound = {
  columns: Array<TableColumnConfig$Outbound>;
  id: string;
  rows: Array<TableRowConfig$Outbound>;
  sorting_state?: TableSortingState$Outbound | undefined;
  title?: string | undefined;
};

/** @internal */
export const TableConfig$outboundSchema: z.ZodType<
  TableConfig$Outbound,
  z.ZodTypeDef,
  TableConfig
> = z.object({
  columns: z.array(TableColumnConfig$outboundSchema),
  id: z.string(),
  rows: z.array(TableRowConfig$outboundSchema),
  sortingState: TableSortingState$outboundSchema.optional(),
  title: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    sortingState: "sorting_state",
  });
});

export function tableConfigToJSON(tableConfig: TableConfig): string {
  return JSON.stringify(TableConfig$outboundSchema.parse(tableConfig));
}
export function tableConfigFromJSON(
  jsonString: string,
): SafeParseResult<TableConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TableConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TableConfig' from JSON`,
  );
}
